module.exports = __webpack_public_path__ + "static/media/aims_main.44e2563c.png";